import React from 'react'
import "./InnerPageHeader.css"
import { Container } from "react-bootstrap";
import { Link } from 'react-router-dom';
import innerHeaderBackground from "../../assets/images/home/bg1.png";

const InnerPageHeader = ({
  path = [],
  title,
  backgroundImage = innerHeaderBackground,
  patternImage = null,
}) => {
  
  const generatePathLinks = () => {
    let accumulatedPath = '';
    return path.map((segment, index) => {
      accumulatedPath += `/${segment.toLowerCase().replace(/\s+/g, '-')}`;
      const isLast = index === path.length - 1;

      return (
        <span key={index}>
          {!isLast ? (
            <>
              <Link to={accumulatedPath} className="about-link">
                <span>{segment}</span>
              </Link>
              {" / "}
            </>
          ) : (
            <span>{segment}</span>
          )}
        </span>
      );
    });
  };

  return (
    <div className="hero-img">
      <img
        src={backgroundImage}
        alt=""
        className="hero-img-background"
        fetchPriority="high"
        loading="eager"
        decoding="async"
        aria-hidden="true"
      />
      {patternImage && (
        <img
          src={patternImage}
          alt=""
          className="hero-img-pattern"
          loading="eager"
          decoding="async"
          aria-hidden="true"
        />
      )}
      <div className="hero-img-overlay" aria-hidden="true" />
      <Container>
        <div className="about-div">
          <div className="about-link">
            {generatePathLinks()}
          </div>
          <div className="about-title">{title}</div>
        </div>
      </Container>
    </div>
  );
}

export default InnerPageHeader
